import { Badge, Card, Modal, LETTER_TEMPLATES, btnPrimary, btnSecondary, btnDanger, inputStyle, labelStyle } from "./shared";

function buildLetterHtml({ title, body, date }) {
  const today = date || new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  const esc = (s) => String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8" />
  <title>${esc(title)}</title>
  <style>
    @page {
      margin: 1in;
      @bottom-center {
        content: "Gibbs Prodigy Group  |  Powered by Leasly  |  Page " counter(page) " of " counter(pages);
        font-size: 9pt; color: #777; font-family: Georgia, serif;
      }
    }
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: Georgia, "Times New Roman", serif; font-size: 12pt; line-height: 1.85; color: #000; background: #fff; }
    .lh { display: flex; justify-content: space-between; align-items: flex-start; padding-bottom: 14pt; border-bottom: 2pt solid #000; margin-bottom: 28pt; }
    .co { font-size: 15pt; font-weight: bold; font-variant: small-caps; letter-spacing: 0.1em; }
    .dt { font-size: 11pt; color: #333; margin-top: 3pt; }
    .da { font-size: 10pt; color: #444; text-align: right; }
    pre { font-family: Georgia, "Times New Roman", serif; font-size: 11pt; line-height: 1.85; white-space: pre-wrap; word-break: break-word; }
    @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
  </style>
</head>
<body>
  <div class="lh">
    <div>
      <div class="co">Gibbs Prodigy Group</div>
      <div class="dt">${esc(title)}</div>
    </div>
    <div class="da">${esc(today)}</div>
  </div>
  <pre>${esc(body)}</pre>
  <script>window.onload = function() { window.print(); }</script>
</body>
</html>`;
}

export default function Documents({
  docsTab, setDocsTab,
  customTemplates, savedDocs,
  showDocModal, setShowDocModal,
  selectedTemplate,
  docTenant, setDocTenant,
  docExtras, setDocExtras,
  docBody, setDocBody,
  docSubject, setDocSubject,
  docSaved,
  tenants, settings,
  openDocModal, saveDocument, deleteDocument,
  viewSavedDoc, setViewSavedDoc,
  showNewTemplate, setShowNewTemplate,
  newTemplate, setNewTemplate, saveCustomTemplate,
  editTemplate, setEditTemplate, updateCustomTemplate,
  deleteCustomTemplate,
  can,
  setShowLeaseWizard,
}) {
  return (
    <>
      {/* ── Documents page ── */}
      <div className="app-page-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, fontSize: 32, color: "#2B2B2B", margin: 0 }}>Documents & Letters</h1>
          <div style={{ color: "#9B9690", marginTop: 4, fontSize: 14 }}>Generate, edit, save, and print tenant letters</div>
        </div>
        {docsTab === "custom" && <button style={btnPrimary} onClick={() => setShowNewTemplate(true)}>+ New Template</button>}
      </div>

      {/* Tabs */}
      <div className="app-doc-tabs" style={{ display: "flex", gap: 4, marginBottom: 24, background: "#FFFFFF", borderRadius: 10, padding: 4, width: "fit-content", border: "1px solid #e0dbd0" }}>
        {[["templates","📋 Preset Templates"], ["custom","✏️ My Templates"], ["saved","📁 Saved Documents"]].map(([key, label]) => (
          <button key={key} onClick={() => setDocsTab(key)} style={{ padding: "8px 18px", borderRadius: 7, border: "none", cursor: "pointer", fontFamily: "inherit", fontWeight: 600, fontSize: 13, background: docsTab === key ? "#163C2F" : "transparent", color: docsTab === key ? "#fff" : "#9B9690" }}>{label}</button>
        ))}
      </div>

      {/* Preset Templates Tab */}
      {docsTab === "templates" && (
        <div className="app-grid-3" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }}>
          {LETTER_TEMPLATES.map(tmpl => (
            <Card key={tmpl.id} style={{ cursor: "pointer" }}
              onMouseEnter={e => e.currentTarget.style.borderColor = "#163C2F"}
              onMouseLeave={e => e.currentTarget.style.borderColor = "#D4CFC7"}
              onClick={() => openDocModal(tmpl, false)}>
              <div style={{ fontSize: 28, marginBottom: 12 }}>{tmpl.icon}</div>
              <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 15, marginBottom: 6 }}>{tmpl.name}</div>
              <div style={{ fontSize: 12, color: "#9B9690", marginBottom: 14 }}>{tmpl.subject}</div>
              <Badge label="Click to Generate" color="#2563eb" />
            </Card>
          ))}
          <Card style={{ cursor: "pointer" }}
            onMouseEnter={e => e.currentTarget.style.borderColor = "#163C2F"}
            onMouseLeave={e => e.currentTarget.style.borderColor = "#D4CFC7"}
            onClick={() => setShowLeaseWizard(true)}>
            <div style={{ fontSize: 28, marginBottom: 12 }}>📜</div>
            <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 15, marginBottom: 6 }}>Lease Agreement</div>
            <div style={{ fontSize: 12, color: "#9B9690", marginBottom: 14 }}>Generate a full residential lease with custom clauses</div>
            <Badge label="5-Step Wizard" color="#163C2F" />
          </Card>
        </div>
      )}

      {/* Custom Templates Tab */}
      {docsTab === "custom" && (
        <>
          {customTemplates.length === 0
            ? <Card><div style={{ color: "#9B9690", textAlign: "center", padding: 24 }}>No custom templates yet — click "+ New Template" to create one</div></Card>
            : <div className="app-grid-3" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }}>
                {customTemplates.map(tmpl => (
                  <Card key={tmpl.id} style={{ cursor: "pointer" }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = "#2563eb"}
                    onMouseLeave={e => e.currentTarget.style.borderColor = "#D4CFC7"}>
                    <div style={{ fontSize: 28, marginBottom: 12 }}>{tmpl.icon || "📄"}</div>
                    <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 15, marginBottom: 6 }}>{tmpl.name}</div>
                    <div style={{ fontSize: 12, color: "#9B9690", marginBottom: 14 }}>{tmpl.subject}</div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      <button onClick={() => openDocModal(tmpl, true)} style={{ ...btnPrimary, fontSize: 12, padding: "6px 12px" }}>Generate</button>
                      <button onClick={() => setEditTemplate({ ...tmpl })} style={{ ...btnSecondary, fontSize: 12, padding: "6px 12px" }}>✏️ Edit</button>
                      <button onClick={() => deleteCustomTemplate(tmpl.id)} style={{ ...btnDanger, padding: "6px 8px" }}>🗑</button>
                    </div>
                  </Card>
                ))}
              </div>
          }
        </>
      )}

      {/* Saved Documents Tab */}
      {docsTab === "saved" && (
        <>
          {savedDocs.length === 0
            ? <Card><div style={{ color: "#9B9690", textAlign: "center", padding: 24 }}>No saved documents yet — generate and save a letter to see it here</div></Card>
            : <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {savedDocs.map((doc, i) => (
                  <Card key={i}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 15 }}>{doc.subject || doc.template}</div>
                        <div style={{ fontSize: 13, color: "#9B9690", marginTop: 4 }}>{doc.tenant} · {doc.template} · {doc.date}</div>
                      </div>
                      <div style={{ display: "flex", gap: 8 }}>
                        <button onClick={() => setViewSavedDoc(doc)} style={{ ...btnSecondary, fontSize: 12, padding: "6px 12px" }}>👁 View</button>
                        <button onClick={() => {
                          const w = window.open("", "_blank");
                          if (!w) { alert("Pop-up blocked — please allow pop-ups for this site."); return; }
                          w.document.write(buildLetterHtml({ title: doc.subject || doc.template, body: doc.body, date: doc.date }));
                          w.document.close();
                        }} style={{ ...btnSecondary, fontSize: 12, padding: "6px 12px" }}>🖨️ Print</button>
                        <button onClick={() => deleteDocument(doc.id)} style={{ ...btnDanger, padding: "6px 8px" }}>🗑</button>
                      </div>
                    </div>
                  </Card>
                ))}
              </div>
          }
        </>
      )}

      {/* ── Modals ── */}

      {/* Document Generator Modal */}
      {showDocModal && selectedTemplate && (() => {
        const tenant = tenants.find(t => t.name === docTenant);
        const isCustom = !selectedTemplate.fields;
        return (
          <div style={{ position: "fixed", inset: 0, background: "#00000099", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div className="app-modal-inner" style={{ background: "#FFFFFF", border: "1px solid #d4cfc4", borderRadius: 16, padding: 28, width: 720, maxWidth: "95vw", maxHeight: "94vh", overflowY: "auto" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
                <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 18 }}>{selectedTemplate.icon || "📄"} {selectedTemplate.name}</div>
                <button onClick={() => setShowDocModal(false)} style={{ ...btnSecondary, padding: "4px 10px" }}>✕</button>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <div>
                    <label style={labelStyle}>Tenant</label>
                    <select value={docTenant} onChange={e => {
                      const t = tenants.find(x => x.name === e.target.value);
                      setDocTenant(e.target.value);
                      if (t && !isCustom) {
                        setDocBody(selectedTemplate.body(t, settings, docExtras));
                      } else if (isCustom) {
                        setDocBody(selectedTemplate.body || "");
                      }
                    }} style={inputStyle}>
                      <option value="">— Select Tenant —</option>
                      {tenants.map(t => <option key={t.name} value={t.name}>{t.name} · {t.address}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Subject / Title</label>
                    <input type="text" value={docSubject} onChange={e => setDocSubject(e.target.value)} style={inputStyle} placeholder="e.g. Rent Increase Notice — April 2026" />
                  </div>
                </div>

                {!isCustom && selectedTemplate.fields && selectedTemplate.fields.length > 0 && (
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                    {selectedTemplate.fields.map(([key, label, type]) => (
                      <div key={key}>
                        <label style={labelStyle}>{label}</label>
                        <input type={type} value={docExtras[key] || ""} onChange={e => {
                          const newExtras = { ...docExtras, [key]: e.target.value };
                          setDocExtras(newExtras);
                          if (tenant) setDocBody(selectedTemplate.body(tenant, settings, newExtras));
                        }} style={inputStyle} />
                      </div>
                    ))}
                  </div>
                )}

                <div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                    <label style={labelStyle}>Letter Content — edit freely</label>
                    {!isCustom && tenant && (
                      <button onClick={() => setDocBody(selectedTemplate.body(tenant, settings, docExtras))} style={{ ...btnSecondary, fontSize: 11, padding: "4px 10px" }}>↺ Reset to template</button>
                    )}
                  </div>
                  <textarea
                    value={docBody}
                    onChange={e => setDocBody(e.target.value)}
                    placeholder={docTenant ? "Letter content will appear here — edit anything you like before saving or printing..." : "Select a tenant above to auto-fill the letter, or type your own content here"}
                    style={{ ...inputStyle, height: 320, resize: "vertical", fontFamily: "'Manrope', sans-serif", fontSize: 12, lineHeight: 1.7 }}
                  />
                </div>
              </div>

              <div style={{ display: "flex", gap: 10, marginTop: 20, justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  {docSaved && <span style={{ color: "#22c55e", fontSize: 13, fontWeight: 600 }}>✅ Saved to tenant history!</span>}
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                  <button onClick={() => setShowDocModal(false)} style={btnSecondary}>Cancel</button>
                  <button disabled={!docBody} onClick={saveDocument} style={{ ...btnSecondary, opacity: docBody ? 1 : 0.4, color: "#22c55e", borderColor: "#22c55e44" }}>💾 Save</button>
                  <button disabled={!docBody} onClick={() => {
                    if (!docBody) return;
                    const w = window.open("", "_blank");
                    if (!w) { alert("Pop-up blocked — please allow pop-ups for this site."); return; }
                    w.document.write(buildLetterHtml({ title: docSubject || selectedTemplate.name, body: docBody }));
                    w.document.close();
                  }} style={{ ...btnPrimary, opacity: docBody ? 1 : 0.4 }}>🖨️ Print / PDF</button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* View Saved Document Modal */}
      {viewSavedDoc && (
        <div style={{ position: "fixed", inset: 0, background: "#00000099", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div className="app-modal-inner" style={{ background: "#FFFFFF", border: "1px solid #d4cfc4", borderRadius: 16, padding: 28, width: 660, maxWidth: "95vw", maxHeight: "92vh", overflowY: "auto" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <div>
                <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 18 }}>{viewSavedDoc.subject || viewSavedDoc.template}</div>
                <div style={{ fontSize: 12, color: "#9B9690", marginTop: 4 }}>{viewSavedDoc.tenant} · {viewSavedDoc.date}</div>
              </div>
              <button onClick={() => setViewSavedDoc(null)} style={{ ...btnSecondary, padding: "4px 10px" }}>✕</button>
            </div>
            <pre style={{ background: "#F5F1EA", border: "1px solid #e0dbd0", borderRadius: 10, padding: 20, fontSize: 13, color: "#2d4a2d", whiteSpace: "pre-wrap", fontFamily: "'Manrope', sans-serif", lineHeight: 1.7 }}>{viewSavedDoc.body}</pre>
            <div style={{ display: "flex", gap: 10, marginTop: 16, justifyContent: "flex-end" }}>
              <button onClick={() => setViewSavedDoc(null)} style={btnSecondary}>Close</button>
              <button onClick={() => {
                const w = window.open("", "_blank");
                if (!w) { alert("Pop-up blocked — please allow pop-ups for this site."); return; }
                w.document.write(buildLetterHtml({ title: viewSavedDoc.subject || viewSavedDoc.template, body: viewSavedDoc.body, date: viewSavedDoc.date }));
                w.document.close();
              }} style={btnPrimary}>🖨️ Print</button>
            </div>
          </div>
        </div>
      )}

      {/* New Custom Template Modal */}
      {showNewTemplate && (
        <Modal title="Create New Template" onClose={() => setShowNewTemplate(false)} onSave={saveCustomTemplate} saveLabel="Save Template">
          <div>
            <label style={labelStyle}>Template Name</label>
            <input type="text" value={newTemplate.name} onChange={e => setNewTemplate(s => ({ ...s, name: e.target.value }))} style={inputStyle} placeholder="e.g. Pool Access Notice" />
          </div>
          <div>
            <label style={labelStyle}>Icon (emoji)</label>
            <input type="text" value={newTemplate.icon} onChange={e => setNewTemplate(s => ({ ...s, icon: e.target.value }))} style={{ ...inputStyle, maxWidth: 80 }} placeholder="📄" />
          </div>
          <div>
            <label style={labelStyle}>Subject / Title</label>
            <input type="text" value={newTemplate.subject} onChange={e => setNewTemplate(s => ({ ...s, subject: e.target.value }))} style={inputStyle} placeholder="e.g. Pool Access Policy Update" />
          </div>
          <div>
            <label style={labelStyle}>Letter Body — write your template here</label>
            <textarea value={newTemplate.body} onChange={e => setNewTemplate(s => ({ ...s, body: e.target.value }))} style={{ ...inputStyle, height: 260, resize: "vertical", fontFamily: "'Manrope', sans-serif", fontSize: 12, lineHeight: 1.7 }} placeholder={"Dear [Tenant Name],\n\nWrite your letter here...\n\nSincerely,\nGibbs Prodigy Group"} />
          </div>
        </Modal>
      )}

      {/* Edit Custom Template Modal */}
      {editTemplate && (
        <Modal title="Edit Template" onClose={() => setEditTemplate(null)} onSave={updateCustomTemplate} saveLabel="Save Changes">
          <div>
            <label style={labelStyle}>Template Name</label>
            <input type="text" value={editTemplate.name} onChange={e => setEditTemplate(s => ({ ...s, name: e.target.value }))} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Icon (emoji)</label>
            <input type="text" value={editTemplate.icon || "📄"} onChange={e => setEditTemplate(s => ({ ...s, icon: e.target.value }))} style={{ ...inputStyle, maxWidth: 80 }} />
          </div>
          <div>
            <label style={labelStyle}>Subject / Title</label>
            <input type="text" value={editTemplate.subject} onChange={e => setEditTemplate(s => ({ ...s, subject: e.target.value }))} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Letter Body</label>
            <textarea value={editTemplate.body} onChange={e => setEditTemplate(s => ({ ...s, body: e.target.value }))} style={{ ...inputStyle, height: 260, resize: "vertical", fontFamily: "'Manrope', sans-serif", fontSize: 12, lineHeight: 1.7 }} />
          </div>
        </Modal>
      )}

    </>
  );
}
